import React, { useState, useEffect } from 'react';
import Header from '../common/header';
import Homebody from '../layout/home/homebody';
import About1 from '../layout/about/about1';
import About from '../common/about1';
import Homebody2 from '../layout/home/homebody2';
import Homebody3 from '../layout/home/homebody3';
import Footer from '../common/footer';
import Service1 from '../common/service1';
import Ourclient from '../common/ourclient';

function Home() {




    return (
        <div>
            <Header />
            <br />
            <Homebody />
            <br />
            <About />
            <br />
            <Service1 />
            <br />
            <Homebody2 />
            {/* <br />
            <Homebody3 /> */}
            <br />
            <Ourclient />
            <br />
            <Footer />
        </div>
    );
}

export default Home;
